import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Accordion, Tab } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PricingCard from "../../components/PricingCard";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  createPageView,
  getUserDetail,
} from "../../store/actions/users/users.actions";
import purpleCircle from "../../assets/img/color_symbol_04.png";
import projectIcon from "../../assets/img/sidebar/svg/projects.svg";
import calculatorIcon from "../../assets/img/sidebar/svg/calculator.svg";
import proposalIcon from "../../assets/img/sidebar/svg/proposal.svg";
import prequalifyIcon from "../../assets/img/sidebar/svg/prequalify.svg";
import my_companyIcon from "../../assets/img/sidebar/svg/my_company.jpg";
import dealsIcon from "../../assets/img/sidebar/svg/deals.svg";
import crmIcon from "../../assets/img/sidebar/crm_2.png";
import Logo from "../../assets/img/sidebar/Logo.png";
import dashboardIcon from "../../assets/img/sidebar/svg/dashboard.svg";
import ContactOutreachIcon from "../../assets/img/contactOutreachIcon.png";
import SiteVisitSheetIcon from "../../assets/img/site_visit.jpg";
import cleaningBidPlanIcon from "../../assets/icons/cleaning-bid-plan.svg";
import paintingBidPlanIcon from "../../assets/icons/painting-bid-plan.svg";
import itbImportIcon from "../../assets/img/sidebar/svg/itb-import.svg";
import allAppsIcon from "../../assets/img/blueCircle.jpg";
import { useDispatch } from "react-redux";
import PricingModal from "../../components/pricingModal";

const StyledCard = styled(Card)`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;

const individualProducts = [
  {
    title: "Capability Statement",
    description: "Create a one-page company profile summary. Update, save, and share.",
    annualPrice: 36,
    monthlyPrice: 6,
    priceId: process.env.REACT_APP_CAPABILITY_STATEMENT,
    monthlyPriceId: process.env.REACT_APP_CAPABILITY_STATEMENT_MONTHLY,
    icon: Logo,
    key: "capability_statement",
  },
  {
    title: "Cleaning Calculator",
    description: "Estimate construction cleaning prices and forecast costs and profit.",
    annualPrice: 108,
    monthlyPrice: 20,
    priceId: process.env.REACT_APP_CLEANING_CALCULATOR,
    monthlyPriceId: process.env.REACT_APP_CLEANING_CALCULATOR_MONTHLY,
    icon: calculatorIcon,
    key: "cleanup_calculator",
    feature: "Cleanup Calculator"
  },
  // {
  //   title: "Cleaning Rates",
  //   description: "Pricing by location and project type—adjust rates and use the slider to calculate your final price.",
  //   annualPrice: 24,
  //   monthlyPrice: 2.99,
  //   priceId: process.env.REACT_APP_CLEANING_RATES,
  //   monthlyPriceId: process.env.REACT_APP_CLEANING_RATES_MONTHLY,
  //   icon: calculatorIcon,
  //   key: "cleanup_rates",
  //   feature: "Cleanup Rates"
  // },
  {
    title: "Contact Management",
    description: "Create and manage contacts, track outreach, and send emails.",
    annualPrice: 0,
    monthlyPrice: 0,
    icon: crmIcon,
    key: "crm",
  },
  {
    title: "Contact Outreach",
    description: "Download or email curated contact lists of top North American general contractors.",
    annualPrice: 84,
    monthlyPrice: 12,
    priceId: process.env.REACT_APP_CONTACT_OUTREACH,
    monthlyPriceId: process.env.REACT_APP_CONTACT_OUTREACH_MONTHLY,
    icon: ContactOutreachIcon,
    key: "contact_outreach",
  },
  {
    title: "Dashboard",
    description: "Track actions made accros platform with charts and date filter.",
    annualPrice: 0,
    monthlyPrice: 0,
    icon: dashboardIcon,
    key: "dashboard",
  },
  // {
  //   title: "Deal Marketplace",
  //   description: "Share deals publicly or add them to your pipeline.",
  //   credits: 50,
  //   priceId: process.env.REACT_APP_DEAL_MARKETPLACE,
  //   icon: dealsIcon,
  //   key: "deal/marketplace",
  // },
  {
    title: "Enrich",
    description: "B2B contacts from commercial vertical building general contractor across the USA and Canada.",
    credits: 50,
    priceId: process.env.REACT_APP_ENRICH,
    icon: purpleCircle,
    key: "enrich",
  },
  {
    title: "Pipeline",
    description: "Track all your deals in one place with a custom pipeline - stay organized and never miss a sales opportunity",
    annualPrice: 0,
    monthlyPrice: 0,
    icon: dealsIcon,
    key: "myganarpro/favorites",
  },
  {
    title: "ITB Import",
    description: "Automatically import Invitation to Bid emails from your Gmail inbox and convert them to deals",
    annualPrice: 69.00,
    monthlyPrice: 6.99,
    priceId: process.env.REACT_APP_ITB_IMPORT,
    monthlyPriceId: process.env.REACT_APP_ITB_IMPORT_MONTHLY,
    icon: itbImportIcon,
    key: "itb-import",
  },
  {
    title: "Planroom",
    description: "Direct access to public bidding opportunities shared by general contractors.",
    annualPrice: 48,
    monthlyPrice: 10,
    priceId: process.env.REACT_APP_PLANROOM,
    monthlyPriceId: process.env.REACT_APP_PLANROOM_MONTHLY,
    icon: prequalifyIcon,
    key: "plan_room",
  },
  {
    title: "Prequalify",
    description: "Access blank vendor pre qualification applications to qualify your company.",
    annualPrice: 48,
    monthlyPrice: 10,
    priceId: process.env.REACT_APP_PREQUALIFY,
    monthlyPriceId: process.env.REACT_APP_PREQUALIFY_MONTHLY,
    icon: prequalifyIcon,
    key: "pre_qualify",
  },
  {
    title: "Project Board",
    description: "Use a map to locate construction projects and view their associated data tables.",
    annualPrice: 156,
    monthlyPrice: 25,
    priceId: process.env.REACT_APP_PROJECT_BOARD,
    monthlyPriceId: process.env.REACT_APP_PROJECT_BOARD_MONTHLY,
    icon: projectIcon,
    key: "project_board",
  },
  {
    title: "Project Research",
    description: "Date table displaying projects based on location and current construction phase.",
    annualPrice: 144,
    monthlyPrice: 24,
    priceId: process.env.REACT_APP_PROJECT_RESEARCH,
    monthlyPriceId: process.env.REACT_APP_PROJECT_RESEARCH_MONTHLY,
    icon: projectIcon,
    key: "project_research",
  },
  {
    title: "Proposal",
    description: "Generate cleaning and painting proposals.",
    annualPrice: 108,
    monthlyPrice: 15,
    priceId: process.env.REACT_APP_PROPOSAL,
    monthlyPriceId: process.env.REACT_APP_PROPOSAL_MONTHLY,
    icon: proposalIcon,
    key: "my_proposal",
  },
  // {
  //   title: "Site Route Router",
  //   description: "Route planning for jobsite visits.",
  //   annualPrice: 60,
  //   monthlyPrice: 6.99,
  //   priceId: process.env.REACT_APP_SITE_ROUTE_ROUTER,
  //   monthlyPriceId: process.env.REACT_APP_SITE_ROUTE_ROUTER_MONTHLY,
  //   icon: projectIcon,
  //   key: "site_router",
  // },
  {
    title: "Site Visit Sheet",
    description: "Form to save and gather information during site visits.",
    annualPrice: 36,
    monthlyPrice: 8,
    priceId: process.env.REACT_APP_SITE_VISIT_SHEET,
    monthlyPriceId: process.env.REACT_APP_SITE_VISIT_SHEET_MONTHLY,
    icon: SiteVisitSheetIcon,
    key: "site_visit",
  },
  {
    title: "QualKey",
    description: "Store your business details in 1 place.",
    annualPrice: 36,
    monthlyPrice: 7,
    priceId: process.env.REACT_APP_QUALKEY,
    monthlyPriceId: process.env.REACT_APP_QUALKEY_MONTHLY,
    icon: my_companyIcon,
    key: "qualkey",
  },
];

const combinationPlans = [
  {
    title: "Cleaning Bid Plan",
    description: "Complete toolkit for cleaning contractors to find and bid on projects",
    products: ["project_board", "project_research", "cleanup_calculator", "my_proposal"],
    monthlyPrice: 39,
    annualPrice: 225,
    monthlyPriceId: process.env.REACT_APP_CLEANING_BID_PLAN_MONTHLY,
    annualPriceId: process.env.REACT_APP_CLEANING_BID_PLAN_ANNUAL,
    icon: cleaningBidPlanIcon,
    key: "cleaning_bid_plan",
    popular: false,
  },
  {
    title: "Painting Bid Plan",
    description: "Complete toolkit for painting contractors to find and bid on projects",
    products: ["project_board", "project_research", "my_proposal"],
    monthlyPrice: 36,
    annualPrice: 200,
    monthlyPriceId: process.env.REACT_APP_PAINTING_BID_PLAN_MONTHLY,
    annualPriceId: process.env.REACT_APP_PAINTING_BID_PLAN_ANNUAL,
    icon: paintingBidPlanIcon,
    key: "painting_bid_plan",
    popular: false,
  },
  {
    title: "All Apps",
    description: "All apps in one plan",
    products: ["project_board", "project_research", "cleanup_calculator", "my_proposal", "plan_room", "pre_qualify", "project_board", "project_research", "my_proposal", "plan_room", "pre_qualify", "itb-import"],
    monthlyPrice: 59,
    annualPrice: 449,
    monthlyPriceId: process.env.REACT_APP_ALL_APPS_MONTHLY,
    annualPriceId: process.env.REACT_APP_ALL_APPS_ANNUAL,
    icon: allAppsIcon,
    key: "all_apps"
  }
];

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PricingPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab');
  
  const [loginModalShow, setLoginModalShow] = useState(false);
  const [pricingModalShow, setPricingModalShow] = useState(false);
  const [appPricing, setAppPricing] = useState("");
  const [billingCycle, setBillingCycle] = useState("annual");
  const [viewMode, setViewMode] = useState(tabParam === 'individual' ? 'individual' : 'bundles');
  const { user: profile } = useSelector((state) => state.userDetails);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const path = window.location.pathname.slice(1);

  useEffect(() => {
    const pageRecord = "Pricing";
    const type = "Pricing";
    if (user) {
      dispatch(createPageView(pageRecord, path, type));
    }

    dispatch(getUserDetail());
  }, [dispatch, path]);

  const getMonthlyPrice = (annualPrice) => {
    return (annualPrice / 12).toFixed(2);
  };

  const getProductByKey = (key) => {
    return individualProducts.find(product => product.key === key);
  };

  const handleCredits = (product) => {
    if (product.key === 'enrich')
      setAppPricing("credit")
    else
      setAppPricing("deals_credit")
    setPricingModalShow(true)
  }

  return (
    <div className="container-fluid bg-white min-vh-100">
      <div className="container p-5">
        <div className="row">
          <h1 className="my-2">Choose Your Ganarpro Tools</h1>
          <h3 className="mb-3 text-muted fw-normal">
            Subscribe to only the services you need. Choose between monthly or annual billing.
          </h3>
          
          {/* View Mode Toggle */}
          <div className="d-flex justify-content-center mb-3">
            <div className="btn-group" role="group">
              <input
                type="radio"
                className="btn-check"
                name="viewMode"
                id="bundles"
                value="bundles"
                checked={viewMode === "bundles"}
                onChange={(e) => setViewMode(e.target.value)}
              />
              <label className="btn btn-outline-primary" htmlFor="bundles">
                Packaged Plans
              </label>

              <input
                type="radio"
                className="btn-check"
                name="viewMode"
                id="individual"
                value="individual"
                checked={viewMode === "individual"}
                onChange={(e) => setViewMode(e.target.value)}
              />
              <label className="btn btn-outline-primary" htmlFor="individual">
                Individual Products
              </label>
              
            </div>
          </div>

          {/* Billing Cycle Toggle - Show for both individual products and bundles */}
          <div className="d-flex justify-content-center mb-4">
            <div className="btn-group" role="group">
              <input
                type="radio"
                className="btn-check"
                name="billingCycle"
                id="annual"
                value="annual"
                checked={billingCycle === "annual"}
                onChange={(e) => setBillingCycle(e.target.value)}
              />
              <label className="btn btn-outline-primary" htmlFor="annual">
                Annual (Save up to 50%)
              </label>
              
              <input
                type="radio"
                className="btn-check"
                name="billingCycle"
                id="monthly"
                value="monthly"
                checked={billingCycle === "monthly"}
                onChange={(e) => setBillingCycle(e.target.value)}
              />
              <label className="btn btn-outline-primary" htmlFor="monthly">
                Monthly
              </label>
            </div>
          </div>
        </div>

        <div className="row">
          {/* {viewMode === "bundles" && <Col md={12} lg={2} xs={12} className="mb-4"></Col>} */}
          {viewMode === "individual" ? individualProducts.map((product, index) => {
            const isAnnual = billingCycle === "annual";
            const currentPrice = isAnnual ? product.annualPrice : product.monthlyPrice;
            const currentPriceId = isAnnual ? product.priceId : product.monthlyPriceId;
            
            const productWithPricing = {
              ...product,
              price: currentPrice || product.credits,
              price_id: currentPriceId,
              billingCycle: billingCycle,
              monthlyEquivalent: product.annualPrice ? getMonthlyPrice(product.annualPrice) : 0
            };

            const hasFeature = profile?.features?.includes(product?.feature ? product.feature : product.title) || product?.credits;

            return (
              <Elements key={product.key} stripe={stripePromise}>
                <Col md={6} lg={4} xs={12} className="mb-4">
                  <StyledCard>
                    <Card.Body className="d-flex flex-column">
                      <div className="text-center mb-3">
                        <img 
                          src={product.icon} 
                          alt={product.title}
                          style={{ width: "60px", height: "60px", objectFit: "contain" }}
                          className="mb-2"
                        />
                        <h5 className="card-title">{product.title}</h5>
                        <p className="card-text text-muted small">{product.description}</p>
                      </div>
                      
                      {currentPrice ? (
                      <div className="text-center mb-3">
                        <div className="h3 mb-0">${currentPrice}</div>
                        <small className="text-muted">
                          per {isAnnual ? 'year' : 'month'}
                        </small>
                        {isAnnual && product.monthlyPrice && (
                          <div className="mt-2">
                            <small className="text-success">
                              ${getMonthlyPrice(product.annualPrice)}/month equivalent
                            </small>
                          </div>
                        )}
                        {!isAnnual && product.annualPrice && (
                          <div className="mt-2">
                            <small className="text-muted">
                              ${product.annualPrice}/year (save ${(product.monthlyPrice * 12 - product.annualPrice).toFixed(2)})
                            </small>
                          </div>
                        )}
                      </div>
                      ) : product.credits && (!profile?.subscriptions?.some((sub) => sub?.status === "active") && product.key !== "enrich") ? (
                        <div className="text-center mb-3">
                          <div className="h3 mb-0">${product.credits}</div>
                          <small className="text-muted">50 credits</small>
                        </div>
                      ) : ''}

                      <div className="mt-auto">
                        {hasFeature || currentPrice == 0 ? (
                          <Button variant="primary" className="w-100 fs-5" onClick={() => navigate(`/${product.key}`)}>
                            View
                          </Button>
                        ) : (
                          <>
                            <PricingCard
                              product={productWithPricing}
                              profile={profile}
                            />
                            <Button variant="primary" className="w-100 mt-2 fs-5" onClick={() => navigate(`/${product.key}`)}>
                              View
                            </Button>
                          </>
                        )}
                        {product.credits && (!profile?.subscriptions?.some((sub) => sub?.status === "active") && product.key !== "enrich") && (
                          <Button variant="primary" className="w-100 mt-2 fs-5" onClick={() => handleCredits(product)}>
                            Buy Credits
                          </Button>
                        )}
                      </div>
                    </Card.Body>
                  </StyledCard>
                </Col>
              </Elements>
            );
          }) : combinationPlans.map((plan, index) => {
            const isAnnual = billingCycle === "annual";
            const currentPrice = isAnnual ? plan.annualPrice : plan.monthlyPrice;
            const currentPriceId = isAnnual ? plan.annualPriceId : plan.monthlyPriceId;
            
            const planWithPricing = {
              ...plan,
              price: currentPrice,
              price_id: currentPriceId,
              monthlyPriceId: plan.monthlyPriceId,
              annualPriceId: plan.annualPriceId,
              billingCycle: billingCycle,
            };

            // Check if user has any of the products in this bundle
            const hasAnyProduct = plan.products.some(productKey => {
              const product = getProductByKey(productKey);
              return product && (profile?.features?.includes(product?.feature ? product.feature : product.title));
            });

            return (
              <Elements key={plan.key} stripe={stripePromise}>
                <Col md={6} lg={4} xs={12} className="mb-4">
                  <StyledCard className={plan.popular ? "border-primary" : ""}>
                    {plan.popular && (
                      <div className="text-center bg-primary text-white py-2">
                        <small className="fw-bold">MOST POPULAR</small>
                      </div>
                    )}
                    <Card.Body className="d-flex flex-column">
                      <div className="text-center mb-3">
                        <img 
                          src={plan.icon} 
                          alt={plan.title}
                          style={{ width: "60px", height: "60px", objectFit: "contain" }}
                          className="mb-2"
                        />
                        <h5 className="card-title">{plan.title}</h5>
                        <p className="card-text text-muted small">{plan.description}</p>
                      </div>
                      
                      <div className="text-center mb-3">
                        <div className="h3 mb-0">${currentPrice}</div>
                        <small className="text-muted">
                          per {isAnnual ? 'year' : 'month'}
                        </small>
                        {isAnnual && plan.monthlyPrice && (
                          <div className="mt-2">
                            <small className="text-success">
                              ${getMonthlyPrice(plan.annualPrice)}/month equivalent
                            </small>
                          </div>
                        )}
                        {!isAnnual && plan.annualPrice && (
                          <div className="mt-2">
                            <small className="text-muted">
                              ${plan.annualPrice}/year (save ${(plan.monthlyPrice * 12 - plan.annualPrice).toFixed(2)})
                            </small>
                          </div>
                        )}
                        {plan.savings > 0 &&
                          <div className="mt-2">
                            <small className="text-success fw-bold">
                              Save ${plan.savings} {isAnnual ? 'annually' : 'monthly'}
                            </small>
                          </div>
                        }
                      </div>

                      {/* Included Products */}
                      <div className="mb-3">
                        <h6 className="text-muted mb-2">Includes:</h6>
                        <div className="row">
                          {plan.products.map((productKey, idx) => {
                            const product = getProductByKey(productKey);
                            if (!product) return null;
                            return (
                              <div key={idx} className="col-6 mb-1">
                                <small className="text-muted">
                                  <i className="fas fa-check text-success me-1"></i>
                                  {product.title}
                                </small>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="mt-auto">
                        <PricingCard
                          product={planWithPricing}
                          profile={profile}
                        />
                      </div>
                    </Card.Body>
                  </StyledCard>
                </Col>
              </Elements>
            );
          })}
        </div>

        {/* Features Section */}
        <Row className="justify-content mt-5">
          <h2 className="text-start my-5 fw-bolder">
            How Subscriptions Work
          </h2>
          <Col md={6} className="text-start">
            <ul>
              <li>Each app is a standalone product with its own license (monthly or annual).</li>
            </ul>
          </Col>
          <Col md={6} className="text-start">
            <ul>
              <li>Subscriptions renew automatically—cancel anytime with no fees.</li>
            </ul>
          </Col>
          <Col md={6} className="text-start">
            <ul>
              <li>You can subscribe to multiple products at once. Annual subscriptions cannot be removed during the one-year term, while monthly subscriptions can be cancelled at any time.</li>
            </ul>
          </Col>
          <Col md={6} className="text-start">
            <ul>
              <li><b>Enrich</b> and <b>Deal Marketplace</b> run on a credit system—no license required; just top up and use as needed.</li>
            </ul>
          </Col>
          <Col md={6} className="text-start">
            <ul>
              <li><b>Annual subscriptions save you up to 50%</b> compared to monthly billing—choose the option that works best for your business.</li>
            </ul>
          </Col>
          <Col md={6} className="text-start">
            <ul>
              <li><b>Bundle plans offer additional savings</b> when you need multiple tools—perfect for growing businesses that want everything in one package.</li>
            </ul>
          </Col>
        </Row>
        <PricingModal
          show={pricingModalShow}
          app={appPricing}
          costs={50}
          onHide={() => setPricingModalShow(false)}
        />
      </div>
    </div>
  );
};

export default PricingPage;
